/**
 * Our window size breakpoints in English form. Easier to think around compared to hard numbers.
 */ export var WindowBreakpoint;
(function(WindowBreakpoint) {
    WindowBreakpoint["DesktopAverageSize"] = "average-desktop";
    WindowBreakpoint["DesktopSmallSize"] = "small-desktop";
    WindowBreakpoint["MobileAverageSize"] = "average-mobile";
})(WindowBreakpoint || (WindowBreakpoint = {}));
export var ElementVisibility;
(function(ElementVisibility) {
    ElementVisibility["Bar"] = "bar";
    ElementVisibility["Menu"] = "menu";
    ElementVisibility["NotIncluded"] = "not-included";
})(ElementVisibility || (ElementVisibility = {}));
